export default __webpack_public_path__ + "0ce2146799d4c6545a3177b419a798e1.png";